
/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class AudiometryComponentsService extends MainService {
  static audiometryBodyParts() {
    return this.postSEC(ServiceConstant.AUDIOMETRY_PART);
  }
  static listRangeHearingLoss(){
    return this.getSEC(ServiceConstant.AUDIOMETRY_RANGEHEARINGLOSS);
  }
}
